import React, { useEffect, useState }  from "react";
import { Helmet } from "react-helmet-async";
import GoogleReviewsWidget from "../components/GoogleReviewsWidget"
function Home() {
    const [workshops, setWorkshops] = useState([]);

    useEffect(() => {
      fetch(
        "https://script.google.com/macros/s/AKfycbzedLNFQ_GVWoinDOP_WeJ7DGcFL4YOgSapcRThedepDa4d-Co95vUxs9eMp1-Xmx79ag/exec"
      )
        .then((res) => res.json())
        .then((data) => setWorkshops(data))
        .catch((err) => console.error("Failed to fetch workshops", err));
    }, []);

    return (
        <div>
            <Helmet>
                <title>Adya Yoga | Yoga, Meditation, Healing in Fuerteventura</title>
                <meta
                  name="description"
                  content="Adya Yoga by Jigyasa offers Yoga, Meditation, and Energy Healing sessions, retreats and courses. Join us to heal body, mind and soul."
                />
                <link rel="canonical" href="https://yogaadya.com/" />
                <meta name="robots" content="index, follow" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Adya Yoga" />
                <meta property="og:title" content="Adya Yoga | Yoga, Meditation, Healing" />
                <meta property="og:description" content="Yoga, Meditation and Energy Therapies by Jigyasa. Workshops, courses and private sessions." />
                <meta property="og:url" content="https://yogaadya.com/" />
                <meta property="og:image" content="https://yogaadya.com/assets/images/yoga-01.png" />
                <meta property="og:image:secure_url" content="https://yogaadya.com/assets/images/yoga-01.png" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:alt" content="Adya Yoga" />
                <meta property="og:locale" content="en_US" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Adya Yoga | Yoga, Meditation, Healing" />
                <meta name="twitter:description" content="Yoga, Meditation and Energy Therapies by Jigyasa." />
                <meta name="twitter:image" content="https://yogaadya.com/assets/images/yoga-01.png" />
                <meta name="twitter:image:alt" content="Adya Yoga" />
                <script type="application/ld+json">
{`{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Adya Yoga",
  "url": "https://yogaadya.com/",
  "sameAs": [
    "https://sheetsofsoul.com/"
  ]
}`}
                </script>
                <script type="application/ld+json">
{`{
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Adya Yoga",
  "url": "https://yogaadya.com/",
  "logo": "https://yogaadya.com/assets/images/logo1.png"
}`}
                </script>
            </Helmet>
            
            {/* about */}    
            <section className ="about py-lg-4 py-md-3 py-sm-3 py-3" id="intro">
                <div className ="container py-lg-5 py-md-4 py-sm-4 py-3">
                <div className ="row">
                    <div className ="col-lg-12 about-imgs-txt">
                    <img src="assets/images/yoga-01.png" alt="Welcome to Adya Yoga" className ="img-fluid"/>
                    </div>        
                </div>                
                <div className ="row">
                    <div className ="col-lg-12 about-two-grids">
                    <h2 className ="text-center">Welcome to Adya Yoga</h2>
                    <div className ="about-para-txt">
                        <p>Adya means first, powerful, primordial energy and Yoga is union. 
                          I am Jigyasa and I firmly believe in the greatness of the practice of Yoga &amp; Meditation. 
                          If followed with dedication &amp; belief, your Yoga practice will make your life a blissful journey.                            
                        </p>
                        <p>
                        Hello blessed souls, My name Jigyasa means curiosity, 
                        I was always keen and eager to learn new things ever since I was a child. 
                        This quest of mine lead to a vast array of knowledge.
                        </p>
                        <p>
                            I started my career as an Insurance agent, moving onto a Workshop consultant with
                            leading newspaper of India, The Times of India. Later I made a switch in Electronic
                            Media, wherein I started as a Creative Sales person and eventually landed up doing
                            a Drive Time Radio show on RED FM. Having tried all forms of creative expression,
                            nothing seemed to satisfy my quest in Life. Eventually my encounter with my Master
                            made me realize what I wished to do in pursuit of quenching my spiritual thirst and
                            helping people.
                        </p>
                        <p>
                            I am a Traditional Yoga Teacher with a Modern age twist. I started practicing Yoga
                            ever since I was a Kid, using the practice as a remedy to help with my Health Issues.
                            Seeing how the practice worked for me, I have believed since then in power of Yoga
                            and Meditation.
                        </p>
                        <p>
                            Originally born, brought up and trained in India, I have been living on the beautiful
                            island of Fuerteventura in Spain for more than 10 years teaching Yoga and practising
                            Energy Therapies. I try that sessions with me will help you heal your Body, Mind and
                            Soul and connect better with your inner-self.
                        </p>
                        <p>
                            Adya signifies something essential and of great importance, Yoga signifies coming
                            together. I pray that this space gives you an opportunity to come in union with your
                            greatness.
                        </p>
                    </div>          
                    </div>
                </div>

                 {/* Upcoming Workshops Section */}
          <div className="row mt-5">
            <div className="col-12">
              <h2 className="text-center mb-4">Upcoming Sessions</h2>
              <div className="row">
                {workshops.map((item, index) => (
                  <div key={index} className="col-md-6 mb-4">
                    <div className="card h-100 shadow-sm">
                      <img
                        src={item["Image"]}
                        alt={item["Discription"]}
                        className="card-img-top img-fluid workshop-image"
                      />
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title">{item["Discription"]}</h5>
                        <a
                          href={item["PaymentUrl"]}
                          className="register-btn mt-auto"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Book Now
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>


                <div className="row mt-5">
                    <GoogleReviewsWidget />
                {/* <!-- Elfsight Google Reviews | Untitled Google Reviews --> */}                
                </div>
                </div>
            </section>
             {/* <GoogleReviewsWidget />          */}   
            {/* CTA Section (replacing removed Contact section) */}
            <section className="footer-bottom py-lg-4 py-md-3 py-sm-3 py-3">
              <div className="container py-lg-5 py-md-4 py-sm-4 py-3">
                <div className="row">
                  <div className="col-12 home-cta-buttons">
                    <a
                      href="https://wa.me/919839188783?text=Hi Jigyasa, I would like to know more about your services."
                      className="cta-btn cta-btn--whatsapp"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Chat on WhatsApp
                    </a>
                    <a href="/contact" className="cta-btn cta-btn--primary">
                      Book Now
                    </a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    )
}

export default Home